import { RestClient } from "./restClient";

export class RoleService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	createRole(role, callback) {
		const url = "/ecosystem/api/roles";
		const body = JSON.stringify({
			role
		});
		this._restClient.exec_post(url, body, callback);
	}

	updateRole(roleId, role, callback) {
		const url = `/ecosystem/api/roles/${roleId}`;
		const body = JSON.stringify({
			role
		});
		this._restClient.exec_put(url, body, callback);
	}

	deleteRole(roleId, callback) {
		const url = `/ecosystem/api/roles/${roleId}`;
		this._restClient.exec_delete(url, callback);
	}

	bulkUpdateRoles(roles, callback) {
		const url = "/ecosystem/api/roles";
		const body = JSON.stringify({
			roles
		});
		this._restClient.exec_put(url, body, callback);
	}

	getByOrg(orgId, callback) {
		const url = `/ecosystem/api/roles/${orgId}`;
		this._restClient.exec_get(url, callback);
	}

	bulkSaveUserRoles(data, callback) {
		const url = `/ecosystem/api/roles/bulkSave`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	bulkSaveRoleFailoverSettings(data, callback) {
		const url = `/ecosystem/api/roles/failover/bulkSave`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}
	getRolesByOrgId(orgId, callback) {
		const url = `/ecosystem/api/roles/${orgId}/getRolesByOrgId`;
		this._restClient.exec_get(url, callback);
	}
}
